module.exports = __webpack_public_path__ + "img/106.አማርኛ.e96d74b4.svg";